module.exports = __webpack_public_path__ + "static/media/digital-agency.dc9a720e.png";